import api from './api';

const MOBILE_SIGNATURE_PATH = '/m/signature';

export const normalizeMobileSignatureUrl = ({ token, mobileUrl }) => {
  if (!token) {
    return mobileUrl || '';
  }

  const fallbackUrl = `${window.location.origin}${MOBILE_SIGNATURE_PATH}/${token}`;

  if (!mobileUrl) {
    return fallbackUrl;
  }

  try {
    const parsedUrl = new URL(mobileUrl);
    const isBackendHost = parsedUrl.hostname === '0.0.0.0' || parsedUrl.port === '8015';

    if (isBackendHost) {
      return fallbackUrl;
    }

    return mobileUrl;
  } catch (error) {
    return fallbackUrl;
  }
};

export const getStoredMobileSignatureToken = (requestUid) => {
  if (!requestUid) {
    return '';
  }

  try {
    return sessionStorage.getItem(`comers_mobile_signature_token_${requestUid}`) || '';
  } catch (error) {
    return '';
  }
};

export const storeMobileSignatureToken = (requestUid, token) => {
  if (!requestUid || !token) {
    return;
  }

  try {
    sessionStorage.setItem(`comers_mobile_signature_token_${requestUid}`, token);
  } catch (error) {
    // Ignore storage failures; the flow can still continue in-memory.
  }
};

export const clearStoredMobileSignatureToken = (requestUid) => {
  if (!requestUid) {
    return;
  }

  try {
    sessionStorage.removeItem(`comers_mobile_signature_token_${requestUid}`);
  } catch (error) {
    // Ignore storage failures.
  }
};

export const generateMobileSignatureLink = async (requestUid) => {
  const response = await api.post(`/requests/${requestUid}/mobile-signature-link`);
  const data = response.data || {};

  return {
    ...data,
    mobile_url: normalizeMobileSignatureUrl({
      token: data.token,
      mobileUrl: data.mobile_url
    })
  };
};

export const fetchCommerceMobileSignatureStatus = async (token) => {
  const response = await api.get(`/mobile-signature/${token}/status`);
  return response.data || {};
};

export const fetchIdentityVerification = async (requestUid, { bypass = false } = {}) => {
  const response = await api.get(`/requests/${requestUid}/identity-verification`, {
    params: bypass ? { bypass: 1 } : undefined
  });
  const payload = response.data?.data || {};

  return {
    verificationUrl: payload.verificationUrl || payload.verification_url || null,
    testingUrl: payload.testing_url || null
  };
};

export const signCommerceMobileContract = async (token, payload) => {
  const response = await api.post(`/mobile-signature/${token}/sign`, payload);
  return response.data || {};
};

export const getStoredCommerceSignatureScope = () => {
  try {
    const storedScope = localStorage.getItem('temp_tokenScope');
    return storedScope ? JSON.parse(storedScope) : {};
  } catch (error) {
    return {};
  }
};
